import React from 'react';
import DateFilter from 'reusable/datafilter';
import Export from 'reusable/export';
import Search from 'reusable/search';
import SortBy from 'reusable/sortby';
import { useTranslation } from 'react-i18next';

interface ToolbarProps {
  searchValue: string;
  sortValue: string;
  dateValue: string;
  currentPage: number;
  onSearchChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onDateChange: (value: string) => void;
  onPageChange: (value: number) => void;
  DataForExport: any[];
  activetab: string;
}

const Toolbar: React.FC<ToolbarProps> = ({
  searchValue,
  sortValue,
  dateValue,
  currentPage,
  onSearchChange,
  onSortChange,
  onDateChange,
  onPageChange,
  DataForExport,
  activetab,
}) => {
  const { t } = useTranslation(['alcohol', 'common']);
  const sortingOptions = [
    { label: t('sort.default', { ns: 'common' }), value: '' },
    { label: t('sort.create-time', { ns: 'common' }), value: 'create_time' },
  ];
  const handleSortChange = (value: string) => {
    onSortChange(value);
    onPageChange(1);
  };

  const handleSearchChange = (value: string) => {
    onSearchChange(value);
    onPageChange(1);
  };

  const handleDateChange = (value: string) => {
    onDateChange(value);
    onPageChange(1);
  };

  const exportFields = [
    { header: 'Driver ID', field: 'user.id' },
    { header: 'Driver Name', field: 'user.name' },
    { header: 'Driver Contact', field: 'user.phone' },
    { header: 'Test Results mg/l', field: 'data' },
    { header: 'Date Time', field: 'testing_time' },
  ];

  const exportFieldsForRecentSubmission = [
    { header: 'Driver ID', field: 'id' },
    { header: 'Driver Name', field: 'name' },
    { header: 'Driver Contact', field: 'phone' },
    {
      header: 'Test Result',
      field: 'alcoholtests',
      customExport: (tests: any[]) => {
        if (!Array.isArray(tests)) return '';
        return tests.map((test) => `${test.data}`).join('; ');
      },
    },
  ];

  const selectedExportFields =
    activetab === 'recentsubmissions'
      ? exportFieldsForRecentSubmission
      : exportFields;

  return (
    <section className="flex flex-row justify-between w-full">
      <div className="flex w-2/5 justify-start">
        <Search
          placeholder={t('table.search')}
          onSearchChange={handleSearchChange}
        />
      </div>
      <div className="flex flex-row space-x-2 items-center">
        <SortBy
          options={sortingOptions}
          defaultValue={sortValue}
          onChange={handleSortChange}
        />
        <DateFilter defaultDate={dateValue} onDateChange={handleDateChange} />
        <Export data={DataForExport} exportFields={selectedExportFields} />
      </div>
    </section>
  );
};

export default Toolbar;
